import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { MyIcon } from '../../common/baseConfig';
import { List } from 'antd';
import moment from 'moment';
import NoneData from "../common/NoneData";
export class CourseManageMyQuestions extends Component {
  state = {
    curPage: 1,
    InterlocutionType: -1,
    allTotal: 0,
    solvedTotal: 0,
    noSolvedTotal: 0,
  };
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    this.onGetCount();
  }
  componentDidMount() {
    this.onLoadMyQuestions();
  }
  onGetCount() {
    //获取总数
    this.props.actions.fetchGetMyInterIocutionCount().then(res => {
      this.setState({
        allTotal: res[0].data.TotalCount,
        solvedTotal: res[1].data.TotalCount,
        noSolvedTotal: res[2].data.TotalCount,
      });
    });
  }
  onLoadMyQuestions() {
    const { curPage, InterlocutionType } = this.state;
    this.props.actions.fetchGetMyInterlocution({
      PageSize: 5,
      PageIndex: curPage,
      PageStatus: 1,
      InterlocutionType,
    });
  }
  onInterlocutionChange(index) {
    this.setState(
      {
        InterlocutionType: index,
        curPage: 1,
      },
      () => {
        this.onLoadMyQuestions();
      },
    );
  }
  onDelInterlocution(item) {
    this.props.actions.fetchDelMyInterIocution({ Ids: item.ID }).then(res => {
      if (res.SuccessResponse) {
        this.onGetCount();
        this.onLoadMyQuestions();
      }
    });
  }
  renderItem(item) {
    return (
      <div key={item.ID} className="my-questions-list-item">
        <div className="content">
          <p>
            <span className="ques">问</span>
            <span>{item.StudentName}</span>
            <span>{moment(new Date(item.AddTime)).format('YYYY-MM-DD HH:mm:ss')}</span>
          </p>
          <p>{item.Content}</p>
        </div>
        {item.NewInterlocution && (
          <div className="content">
            <p>
              <span className="answer">答</span>
              <span>{item.NewInterlocution.AccountName}</span>
              <span>
                {moment(new Date(item.NewInterlocution.AddTime)).format('YYYY-MM-DD HH:mm:ss')}
              </span>
            </p>
            <p>{item.NewInterlocution.Content}</p>
          </div>
        )}
        <h5>
          <span className="source">
            来源:{item.CourseName} {item.ChapterName}
          </span>
          <span className="del" onClick={this.onDelInterlocution.bind(this, item)}>
            <MyIcon type="iconshanchu1" />
          </span>
        </h5>
      </div>
    );
  }
  render() {
    const { fetchGetMyInterlocutionPending, fetchGetMyInterlocutionSuccess } = this.props.center;
    const { curPage, allTotal, solvedTotal, noSolvedTotal, InterlocutionType } = this.state;

    return (
      <div className="center-course-manage-my-questions">
        <div className="my-questions-radios">
          <div
            className={`my-questions-radio ${
              InterlocutionType === -1 ? 'my-questions-radio-checked' : ''
              }`}
            onClick={this.onInterlocutionChange.bind(this, -1)}
          >
            <span>全部({allTotal})</span>
          </div>
          <div
            className={`my-questions-radio ${
              InterlocutionType === 1 ? 'my-questions-radio-checked' : ''
              }`}
            onClick={this.onInterlocutionChange.bind(this, 1)}
          >
            <span>已解决({solvedTotal})</span>
          </div>
          <div
            className={`my-questions-radio ${
              InterlocutionType === 0 ? 'my-questions-radio-checked' : ''
              }`}
            onClick={this.onInterlocutionChange.bind(this, 0)}
          >
            <span>未解决({noSolvedTotal})</span>
          </div>
        </div>
        <div className="my-questions-list">
          {fetchGetMyInterlocutionSuccess && fetchGetMyInterlocutionSuccess.length > 0 && (
            <List
              itemLayout="horizontal"
              size="large"
              pagination={{
                onChange: page => {
                  this.setState(
                    {
                      curPage: page,
                    },
                    () => {
                      this.onLoadMyQuestions();
                    },
                  );
                },
                current: curPage,
                total:
                  InterlocutionType === -1
                    ? allTotal
                    : InterlocutionType === 1
                      ? solvedTotal
                      : noSolvedTotal,
                pageSize: 5,
              }}
              loading={fetchGetMyInterlocutionPending}
              dataSource={fetchGetMyInterlocutionSuccess}
              renderItem={item => this.renderItem(item)}
            />
          )}
          {
            fetchGetMyInterlocutionSuccess && fetchGetMyInterlocutionSuccess.length === 0 &&
            <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CourseManageMyQuestions);



// WEBPACK FOOTER //
// ./src/features/center/CourseManageMyQuestions.js